import {TOKEN_REVOKED} from "../constants";

const tokenRevoked = () => ({
  type : TOKEN_REVOKED,
});

export default tokenRevoked;
